"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PublicList = _interopRequireDefault(require("./components/PublicList"));
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    PublicList: _PublicList.default
  },
  data: function data() {
    return {
      unionCode: 'WPH'
    };
  }
};